import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import autobind from 'react-autobind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FormBase from '../FormBase';

import {
  changeStep,
  verifyPatientInfo,
  submitForm,
  clearReplaceForm,
} from '../../actions/pharmaReplaceForm';

import ReplaceForm from './Replace';
import Finish from './Finish';

class PharmaReplace extends Component {
  constructor (props) {
    super(props);
    autobind(this);
    const { dispatch } = props;
    this.boundActionCreators = bindActionCreators({
      changeStep,
      verifyPatientInfo,
      submitForm,
      clearReplaceForm,
    }, dispatch);
    this.state = {
      formReady: false,
    };
    dispatch(clearReplaceForm());
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (!nextProps.isLoading && nextProps.success.Code && !prevState.formReady) {
      nextProps.history.push(`/${nextProps.match.params.environment}${prevState.path}`);
      return {
        ...prevState,
        formReady: true,
      };
    } else if (!nextProps.success.Code) {
      return {
        ...prevState,
        formReady: false,
      };
    }
    return prevState;
  }

  componentWillUnmount () {
    this.setState({
      formReady: false,
    });
    this.props.dispatch(clearReplaceForm());
  }

  clearForm () {
    this.props.dispatch(clearReplaceForm());
  }

  handleOnSubmitForm = ({ values, path }) => {
    this.handleOnChangeField(values);
    this.setState({
      path,
    });
    this.props.dispatch(submitForm());
  };

  handleOnChangeField (payload) {
    const { dispatch } = this.props;
    dispatch(verifyPatientInfo(payload));
  }

  render () {
    const { params, path } = this.props.match;
    return (
      <FormBase
        environment={ params.environment }
        patientName="PhyllisShort"
        customClass="form pharma-screen"
        isLoading={ this.props.isLoading }
      >
        <Switch>
          <Route
            path={ `${path}/patient-information` }
            component={ props => (
              <ReplaceForm
                environment={ props.match.params.environment }
                onSubmit={ this.handleOnSubmitForm }
              />
            ) }
          />
          <Route
            path={ `${path}/finish` }
            component={ props => (
              <Finish
                code={ this.props.success.Code }
                clearForm={ this.clearForm }
                cardId={ this.props.success.CardID || '' }
                groupId={ this.props.success.GroupID || '' }
              />
            ) }
          />
        </Switch>
      </FormBase>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.pharmaReplaceForm.loading,
  success: state.pharmaReplaceForm.success,
});

export default withRouter(connect(mapStateToProps)(PharmaReplace));
